import React, { useEffect } from "react";
import MonogramVariantSelector from "./MonogramVariantSelector";
import { withMonogramContext } from "./MonogramContext";
import MonogramTextInput from "./MonogramTextInput";
import MonogramFontStyles from "./MonogramFontStyles";
import MonogramThreadColors from "./MonogramThreadColors";
import MonogramDecorativeColors from "./MonogramDecorativeColors";
import MonogramPositionDropdown from "./MonogramPositionDropdown";
import { getParamFromUrl } from "./util";
import MonogramOutlineColors from "./MonogramOutlineColors";
import MonogramDropShadowColors from "./MonogramDropShadowColors";
import MonogramUpload from "./MonogramUpload";

function MonogramInitialsDrawer({
  setTextValue,
  inputRules,
  setInputRules,
  chosenFont,
  uploadedFile,
}) {
  useEffect(() => {
    const initialTextValue = getParamFromUrl("text");
    if (initialTextValue) {
      setTextValue(initialTextValue);
    } else {
      setTextValue("");
    }
    setInputRules({
      ...inputRules,
      rule: (v) =>
        (chosenFont.special_character
          ? v.replace(new RegExp(`\\${chosenFont.special_character}`, "g"), "")
          : v
        ).length === 3,
      message: "Please enter exactly 3 characters to add to bag",
    });
  }, []);

  return (
    <div>
      <MonogramFontStyles />
      {chosenFont?.allow_upload ? (
        <MonogramUpload maxLength={3} />
      ) : (
        <MonogramTextInput maxLength={3} />
      )}
      <MonogramPositionDropdown />
      <div className="monogram-options-with-border">
        <MonogramVariantSelector />
        <MonogramThreadColors />
        {!!chosenFont?.allow_border_color && <MonogramOutlineColors />}
        {!!chosenFont?.allow_drop_shadow && <MonogramDropShadowColors />}
        {!!chosenFont?.decorative_svg && !chosenFont.disable_decorative_colors && (
          <MonogramDecorativeColors />
        )}
      </div>
      {/* <MonogramVariantSelector /> */}
    </div>
  );
}

export default withMonogramContext(MonogramInitialsDrawer);
